import CTNDropdown from '@ctn/ui/components/ctn-dropdown';
import CTNInput from '@ctn/ui/components/ctn-input';

import { useEmpresa } from '@/context/empresa.context';

import type { ReactElement } from 'react';

const DatosDeLaEmpresa = (): ReactElement => {
	const { control, tiposDeVia, checkCPError, errorCP, checkField, errorEmail} = useEmpresa();

	return (
		<section className='o-grid'>
			<p className='c-pnp-heading-h4'>Datos de la empresa</p>
			<div className='[ o-grid__row ][ u-mt-16 ]'>
				<CTNInput
					disabled control={control} type="text"
					label='nif'
					classNameField='o-grid__col-6 o-grid__col-4@portrait' name="emisor.nif" />				
				<CTNInput 
					disabled control={control} type="text"
					label='Sector'
					classNameField='o-grid__col-6 o-grid__col-4@portrait' name="emisor.tipoSector.descripcion"/>
			</div>
			<div className='o-grid__row'>
				<CTNInput
					required control={control} type="text"
					label='Correo electrónico' 
					classNameField='o-grid__col-12 o-grid__col-4@portrait' name="emisor.email" maxLength={100} 
					error={checkField('emisor.email') ?? errorEmail}/>
				<CTNInput
					control={control} type="number" label='Tel. Call Center' 
					classNameField='o-grid__col-12 o-grid__col-4@portrait' name="emisor.telefono" />
			</div>
			<div className='o-grid__row'>
				<CTNDropdown
					filter
					required
					options={tiposDeVia?.map((td) => ({
						label: td.descripcion,
						value: td.codigo,
					})) ?? []}
					classNameField='o-grid__col-12 o-grid__col-2@portrait'
					name="emisor.direccion.codTipoVia"
					label="Tipo de vía"
					control={control}
					appendTo='body'
					error={checkField('emisor.direccion.codTipoVia')}
				/>
				<CTNInput
					required control={control} type="text"
					label='NOMBRE DE VÍA' 
					classNameField='o-grid__col-12 o-grid__col-8@portrait' name="emisor.direccion.nombreVia" maxLength={400}
					error={checkField('emisor.direccion.nombreVia')}/>
			</div>
			<div className='o-grid__row'>
				<CTNInput
					required control={control} type="text"
					label='Número' 
					classNameField='o-grid__col-4 o-grid__col-2@portrait' name="emisor.direccion.numeroVia" maxLength={50}
					error={checkField('emisor.direccion.numeroVia')} />
				<CTNInput
					control={control} type="text" label='Bloque' 
					classNameField='o-grid__col-4 o-grid__col-2@portrait' name="emisor.direccion.bloque" maxLength={4}/>
				<CTNInput
					control={control} type="text" label='Escalera' 
					classNameField='o-grid__col-4 o-grid__col-2@portrait' name="emisor.direccion.escalera" maxLength={2}/>
				<CTNInput
					control={control} type="text" label='Piso' 
					classNameField='o-grid__col-4 o-grid__col-2@portrait' name="emisor.direccion.piso" maxLength={10}/>
				<CTNInput
					control={control} type="text" label='Puerta' 
					classNameField='o-grid__col-4 o-grid__col-2@portrait' name="emisor.direccion.puerta" maxLength={3}/>
			</div>
			<div className='o-grid__row'>
				<CTNInput
					required control={control} type="text"
					label='Código Postal' 
					classNameField='o-grid__col-12 o-grid__col-4@portrait' name="emisor.direccion.codigoPostal" maxLength={5}
					error={checkField('emisor.direccion.codigoPostal') ?? errorCP}
					onBlur={checkCPError}/>
				<CTNInput
					disabled
					control={control} type="text" label='Provincia' 
					classNameField='o-grid__col-12 o-grid__col-4@portrait' name="emisor.direccion.descripcionProvincia"/>
				<CTNInput
					disabled
					control={control} type="text" label='Municipio' 
					classNameField='o-grid__col-12 o-grid__col-4@portrait' name="emisor.direccion.descripcionMunicipio"/>
			</div>
		</section>
	);
};

export default DatosDeLaEmpresa;
